export function isEmptyObject(obj) {
  return Object.entries(obj).length === 0 && obj.constructor === Object
}

export function isInternal(url) {
  if (!url) return false
  if (url.startsWith("mailto:")) return false
  if (url.startsWith("tel:")) return false
  if (url.startsWith("https://admin")) return true
  if (url.startsWith("http")) return false
  return true
}

export function relativeNonHook(url) {
  if (!url) return undefined

  const WPURL = "https://admin.dixieply.com"
  let string = url
  if (url.startsWith("/")) return url
  string = string.replace(WPURL, "")
  return string
}

export function randomID() {
  return Math.random()
    .toString(36)
    .substring(7)
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "")
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3]
  }
  return null
}

export function decodeHTMLEntities(text) {
  if (typeof window === "undefined" || !window.document) return
  
  var textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
}
